// extracted by mini-css-extract-plugin
export default {"main":"Gallery_main__tDcJN","container":"Gallery_container__TCR+b","gallery":"Gallery_gallery__FvAYH","img":"Gallery_img__QW9de","tall":"Gallery_tall__ZUUpW"};